
import {mapContext} from "@/context/global.js";
import {
    Layer,
    LAYER_TYPE_VECTOR_COMMON,
    LAYER_TYPE_VECTOR_ELEVATION
} from "@/engine/layers/layer.js";
import {shortLivedTokenManager} from "@/context/global.js";

const VECTOR_LAYER_CHANGEABLE_TYPES = [
    LAYER_TYPE_VECTOR_COMMON,
    LAYER_TYPE_VECTOR_ELEVATION
]

class VectorLayer extends Layer {

    constructor(struct) {
        struct.styleOptions = [
            'color',
            'weight',
            'fillColor',
            'fillOpacity',
            'dashArray',
            'opacity',
            'lineCap',
            'lineJoin',
            'dashOffset',
            'stroke',
            'fillRule',
            'fill',
            'font-size',
            'font-weight'
        ]

        super(struct)

        this.defaultProperties = {
            name: "newFeature",
            descr: ""
        }

        this.preview            = null
        this.typeVector         = true // is used by mustache templates
        this.dataType           = struct.dataType;
        this.editable           = struct.editable;
        this.metadata           = struct.metadata;
        this.hasElevation       = this.metadata && this.metadata.feature && this.metadata.feature.z.max

        this._changed           = false;  // there is geometries we need to save()
        this._deferSave         = false;  // when true, the WFST save() operation is suppressed

        this.tooltipConfiguration = {direction: "top", permanent: true, offset: [0, -20], opacity: 0.7, className: "tooltip-label"}

        if (new.target === VectorLayer) {
            this._fireNew();
        }
    }

    addOnMap(map, constructor) {
        super.addOnMap(map)

        if (typeof constructor === "function")
            this.layer = constructor()

        if (this.visible)
            this._show()
    }

    // calls on deleting the layer
    removeFromMap() {
        if (this.layer)
            this.layer.remove()

        this.layer = null
    }

    getBoundsUrl() {
        if (this.dataset_bounds == null)
            return ""
        let sw = this.dataset_bounds.getSouthWest()
        let ne = this.dataset_bounds.getNorthEast()
        return `${sw.lng}%2C${sw.lat}%2C${ne.lng}%2C${ne.lat}`
    }

    getPreview() {
        let boundsUrl = this.getBoundsUrl()
        if (boundsUrl === "") {
            //return super.getPreview()
            return null
        }
        const previewUrl = `${this._joinServerUrl(`${this.workspace.id}/wms`)}?service=WMS&version=1.1.0&request=GetMap&layers=${this.workspace.id}%3A${this.id}&bbox=${boundsUrl}&width=100&height=100&srs=EPSG%3A4326&format=image/png`
        return this.addAuthToken(
            previewUrl,
            shortLivedTokenManager.getToken()
        )
    }

    // return leaflet or current VectorLayer style options
    _styleOptions(leafletLayer) {
        if (!leafletLayer)
            leafletLayer = this
        let r = {};
        for (let i in this.styleOptions) {
            if (leafletLayer.options[this.styleOptions[i]])
                r[this.styleOptions[i]] = leafletLayer.options[this.styleOptions[i]];
        }
        return r;
    }

    updateProperties(struct) {
        let changed = super.updateProperties(struct, true);
        for (let prop of ["elevation"]) {
            if (prop in struct) {
                if (prop === "elevation") {
                    if (struct[prop]) {
                        changed |= this.changeType(LAYER_TYPE_VECTOR_ELEVATION)
                    } else {
                        changed |= this.changeType(LAYER_TYPE_VECTOR_COMMON)
                    }
                }
            }
        }

        if (changed) {
            if (this.updatePropertiesHandler)
                this.updatePropertiesHandler(this);
            mapContext.fire("layer:updateProperties", {layer: this, properties: struct});
        }

        return changed;
    }

    saveStyle() {
        if (this.updatePropertiesHandler)
            this.updatePropertiesHandler(this);
    }

    changeType(type, commit) {
        if (this.dataType === type)
            return false
        if (! VECTOR_LAYER_CHANGEABLE_TYPES.includes(type)) {
            return false
        }

        this.dataType = type
        // todo add a switching logic

        if (commit && this.updatePropertiesHandler)
            this.updatePropertiesHandler(this)

        return true
    }
}

export {VectorLayer};
